<template>
    <div class="mainMessageContainer mw-450px">
        <div class="catalog-content d-flex align-items-center">
            <div class="bg-white h-100 px-3 py-4 rounded-start">
                <img class="h-30px w-30px rounded" :src="message?.extra_data?.image ?? loadFile(images.logo)" alt="">
            </div>
            <div class="catalog-text w-100 rounded-end">
                <div class="h-20px overflow-hidden">
                    {{ message?.extra_data?.product_name }}
                </div>
                <div class="textMessage text-truncate">
                    {{ message?.extra_data?.price }}
                </div>
            </div>
        </div>
        <div class="messageContent mt-2">
            <p class="textContent lh-base mb-0">
                {{ message?.content?.interactive?.body?.text }}
            </p>
        </div>
    </div>
</template>
<script setup>
import { loadFile } from '@/components/utils.js'

const images = {
    logo: 'logo_white_backgournd.png'
}

const props = defineProps({
    message: {
        type: Object,
        default: () => ({}),
        required: true,
    },
    profile: String
});
</script>


<style scoped lang="scss">
.textContent {
    white-space: pre-wrap;
}

.mainMessageContainer {
    padding: 12px;
    background-color: #FAE4CB;
    border-radius: 8px;
}

.catalog-text {
    background: #DBC3A7;
    padding: 7px 15px;
}
</style>
